import { render, staticRenderFns } from "./IconArchiveSolid.vue?vue&type=template&id=b0f9c99a"
import script from "./IconArchiveSolid.vue?vue&type=script&lang=js"
export * from "./IconArchiveSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports